"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../utils");

var _Flyout = _interopRequireDefault(require("./Flyout"));

var _FlyoutContext = require("./FlyoutContext");

var _constants = require("./constants");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var WithFlyoutWithoutDocs = function WithFlyoutWithoutDocs(_ref) {
  var children = _ref.children,
      renderFlyout = _ref.renderFlyout,
      shouldCloseOnClickOutside = _ref.shouldCloseOnClickOutside,
      _ref$flyoutPosition = _ref.flyoutPosition,
      flyoutPosition = _ref$flyoutPosition === void 0 ? _constants.withFlyoutDefaultProps.flyoutPosition : _ref$flyoutPosition,
      onClose = _ref.onClose,
      role = _ref.role,
      dataTestId = _ref.dataTestId,
      zIndex = _ref.zIndex;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var flyoutTitleId = (0, _react.useMemo)(function () {
    return "".concat(_constants.FLYOUT_TITLE_ID, "-").concat((0, _utils.getUniqueId)());
  }, []);
  var ref = (0, _react.useRef)(null);
  var open = (0, _react.useCallback)(function () {
    setIsOpen(true);
  }, []);
  var close = (0, _react.useCallback)(function () {
    setIsOpen(false);
  }, []); // This is separate because it is only passed to the <Flyout> itself. Whenever
  // `close` is passed to a render function, it must not include the onClose()
  // call otherwise the callback will be called twice - once when the consumer
  // calls close() and once when the focus trap deactivates.

  var closeWithCallback = function closeWithCallback() {
    close();
    !!onClose && onClose();
  };

  var contextValue = (0, _react.useMemo)(function () {
    return {
      flyoutTitleId: flyoutTitleId
    };
  }, [flyoutTitleId]);
  return (0, _core.jsx)(_FlyoutContext.FlyoutContext.Provider, {
    value: contextValue
  }, children({
    open: open,
    close: close,
    isOpen: isOpen
  }), (0, _core.jsx)(_Flyout.default, {
    ref: ref,
    isOpen: isOpen,
    close: closeWithCallback,
    shouldCloseOnClickOutside: shouldCloseOnClickOutside,
    position: flyoutPosition,
    role: role,
    dataTestId: dataTestId,
    "aria-labelledby": flyoutTitleId,
    zIndex: zIndex
  }, renderFlyout({
    close: close,
    ref: ref
  })));
};

var WithFlyout = (0, _stencilReactDesc.describe)(WithFlyoutWithoutDocs).description('FAC component for displaying a flyout.');
WithFlyout.propTypes = {
  children: _stencilReactDesc.PropTypes.func.isRequired.description('Render function used to trigger a flyout.').format("({\n  open: () => void,\n  close: () => void,\n  isOpen: boolean\n}) => React.ReactNode\n  "),
  renderFlyout: _stencilReactDesc.PropTypes.func.isRequired.description('Render function to render the content of the flyout.').format("({\n  close: () => void,\n  ref: node\n}) => React.ReactNode"),
  shouldCloseOnClickOutside: _stencilReactDesc.PropTypes.bool.description('Whether the flyout can be closed by clicking outside of it.'),
  flyoutPosition: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.FlyoutPosition)).description('Horizontal position to display the flyout.'),
  onClose: _stencilReactDesc.PropTypes.func.description('Callback called when the flyout is closed.').format('() => void'),
  role: _stencilReactDesc.PropTypes.string.description("Sets the ARIA 'role' attribute on the flyout container."),
  dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes.")
};
WithFlyout.defaultProps = _objectSpread({}, _constants.withFlyoutDefaultProps);
WithFlyout.displayName = 'WithFlyout';
var _default = WithFlyout;
exports.default = _default;